// Constants
import { ModalType } from "@ms/uno-constants/lib/local/ModalType";
import { TaskEditorPanelDialogFallbackBreakpoint } from "@ms/uno-constants/lib/local/UIConstants";
import { TaskEditorRenderMode } from "@ms/planner-models/lib/local/types/TaskEditorRenderMode";
// Styles
import { TaskEditorPanelMaxWidth, TaskEditorPanelWidthRatio } from "@ms/planner-presentational-controls/lib/local/taskEditorContent/TaskEditorContent.styles";
/** Blurs the focused task editor field so its normal commit handler runs before the editor remounts. */ export function commitActiveTaskEditorEdit() {
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement && activeElement.closest("[data-commit-on-resize]")) {
        activeElement.blur();
    }
}
/** Task editor panel width for a base region width: a capped fraction of the region. */ export function getTaskEditorPanelWidth(baseWidth) {
    return Math.min(Math.round(baseWidth * TaskEditorPanelWidthRatio), TaskEditorPanelMaxWidth);
}
/** Whether the task editor panel occupies layout space: flight on, Panel mode, wide viewport, and an open task editor modal. */ export function isTaskEditorPanelActive(viewStore, modalStore, isTaskEditorPanelEnabled) {
    if (!isTaskEditorPanelEnabled) {
        return false;
    }
    if (viewStore.getTaskEditorRenderMode() !== TaskEditorRenderMode.Panel) {
        return false;
    }
    // Responsive fallback: at narrow widths the editor renders as a dialog, not a side panel.
    if (window.innerWidth <= TaskEditorPanelDialogFallbackBreakpoint) {
        return false;
    }
    return modalStore.getCurrentModalDataLayers().some((modal)=>modal.modalType === ModalType.TaskEditor);
}
/** The open task editor modal when the panel is active, otherwise undefined (single-guard convenience over isTaskEditorPanelActive). */ export function getActiveTaskEditorPanelModal(viewStore, modalStore, isTaskEditorPanelEnabled) {
    if (!isTaskEditorPanelActive(viewStore, modalStore, isTaskEditorPanelEnabled)) {
        return undefined;
    }
    return modalStore.getCurrentModalDataLayers().find((modal)=>modal.modalType === ModalType.TaskEditor);
}
/** Primary view width minus the task editor panel width when the panel is open (getPrimaryViewWidth already excludes left nav + Copilot sidecar). */ export function getPrimaryViewContentWidth(viewStore, modalStore, isTaskEditorPanelEnabled) {
    const baseWidth = viewStore.getPrimaryViewWidth();
    if (!isTaskEditorPanelActive(viewStore, modalStore, isTaskEditorPanelEnabled)) {
        return baseWidth;
    }
    return baseWidth - getTaskEditorPanelWidth(baseWidth);
}
